var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalIconSmallWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 0.25H5.125V2.78688C6.01958 2.8852 6.8772 3.19802 7.625 3.69875V0.25ZM3.875 0.25H1.375V3.69875C2.1228 3.19802 2.98042 2.8852 3.875 2.78688V0.25ZM4.5 12.75C5.66032 12.75 6.77312 12.2891 7.59359 11.4686C8.41406 10.6481 8.875 9.53532 8.875 8.375C8.875 7.21468 8.41406 6.10188 7.59359 5.28141C6.77312 4.46094 5.66032 4 4.5 4C3.33968 4 2.22688 4.46094 1.40641 5.28141C0.585936 6.10188 0.125 7.21468 0.125 8.375C0.125 9.53532 0.585936 10.6481 1.40641 11.4686C2.22688 12.2891 3.33968 12.75 4.5 12.75V12.75ZM3.73438 7.42563L4.5 5.875L5.26563 7.42563L6.97688 7.67375L5.73875 8.88125L6.03125 10.5856L4.5 9.78125L2.96938 10.5856L3.26188 8.88125L2.02375 7.67375L3.73438 7.42563V7.42563Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalIconSmallWhite);
export default __webpack_public_path__ + "static/media/MedalIconSmallWhite.46ac297f.svg";
export { ForwardRef as ReactComponent };